import { useCallback, useEffect, useRef, useState } from 'react';
import useWindowResize from './useWindowResize';

export const useIsOverflow = (callback?: (hasOverflow: boolean) => void) => {
  const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined);
  const isResized = useWindowResize();
  const nodeRef = useRef<HTMLElement | null>(null);

  const setRef = useCallback((node: HTMLElement | null) => {
    nodeRef.current = node;
  }, []);

  useEffect(() => {
    const node = nodeRef.current;
    if (!node) return;

    const trigger = () => {
      const hasOverflow = (node.scrollHeight ?? 0) > (node.clientHeight ?? 0);
      setIsOverflow(hasOverflow);
      callback?.(hasOverflow);
    };

    const id = setTimeout(trigger, 500);
    return () => clearTimeout(id);
  }, [callback, isResized]);

  return { setRef, isOverflow };
};
